import styled, { keyframes } from 'styled-components';

const walletAppear = keyframes`
  from { opacity: 0; transform: translateX(10px); }
  to { opacity: 1; transform: translateX(0); }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 0;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  animation: ${walletAppear} 0.3s ease-out;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 500px) {
    background: transparent !important;
    border: none !important;
    border-bottom: none !important;
    padding: 4px 0 !important;
  }
`;

export const Address = styled.div`
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  color: #00ff66;
  text-decoration: none;
  transition: all 0.2s;
  white-space: nowrap;

  ${Container}:hover & {
    color: #66ffaa;
    text-shadow: 0 0 10px rgba(0, 255, 102, 0.5);
  }

  @media (max-width: 500px) {
    font-size: 12px;
  }

  @media (max-width: 900px) and (orientation: landscape) {
    font-size: 13px;
    white-space: nowrap;
  }
`;

export const Roi = styled.div`
  font-family: 'Share Tech Mono', monospace;
  font-size: 12px;
  color: rgba(0, 255, 102, 0.6);
  white-space: nowrap;

  @media (max-width: 500px) {
    font-size: 10px;
  }

  @media (max-width: 900px) and (orientation: landscape) {
    font-size: 11px;
    white-space: nowrap;
  }
`;
